import React from 'react';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { useTranslation } from 'react-i18next';

import type { UserProfileAddress } from '../../../types/user';

import './style.scss';

export interface AddressTeaserProps {
  isDefault?: boolean,
  address: ImmutableEntity<UserProfileAddress>,
}

const AddressTeaser: React.FC<AddressTeaserProps> = ({
  isDefault = false,
  address,
}) => {
  const { t } = useTranslation();
  const firstName = address.get('given_name');
  const lastName = address.get('family_name');
  const addressLine1 = address.get('address_line1');
  const addressLine2 = address.get('address_line2');
  const addressLine3 = address.get('address_line3');
  const postalCode = address.get('postal_code');
  const locality = address.get('locality');
  const organization = address.get('organization');

  return (
    <div className="AddressTeaser">
      {isDefault && (
        <div className="AddressTeaser__default">
          {t('address.is_default_address')}
        </div>
      )}
      {organization && (
        <div className="AddressTeaser__line">
          {organization}
        </div>
      )}
      <div className="AddressTeaser__line1">
        {firstName} {lastName}
      </div>
      <div className="AddressTeaser__line2">
        {addressLine1} {addressLine2} {addressLine3}
      </div>
      <div className="AddressTeaser__line3">
        {postalCode} {locality}
      </div>
    </div>
  );
};

export default AddressTeaser;
